import { useState, type ReactNode } from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import {
  sortCatalog,
  type CatalogEntry,
  type CatalogOrder
} from "./sortCatalog";

export function SortedCatalog<T extends CatalogEntry>({
  items,
  label,
  renderItem,
  limit,
  defaultOrder = "newest",
  popularityScores,
  compact = false
}: {
  items: readonly T[];
  label: string;
  renderItem: (item: T) => ReactNode;
  limit?: number;
  defaultOrder?: CatalogOrder;
  popularityScores?: Readonly<Record<string, number>>;
  compact?: boolean;
}) {
  const [order, setOrder] = useState<CatalogOrder>(defaultOrder);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
        <TextField
          select
          label={label}
          value={order}
          onChange={(event) => setOrder(event.target.value as CatalogOrder)}
          size="small"
          sx={{ minWidth: 200 }}
        >
          {popularityScores !== undefined && (
            <MenuItem value="popular">Most popular</MenuItem>
          )}
          <MenuItem value="newest">Newest first</MenuItem>
          <MenuItem value="oldest">Oldest first</MenuItem>
          <MenuItem value="title-asc">Title: A–Z</MenuItem>
          <MenuItem value="title-desc">Title: Z–A</MenuItem>
        </TextField>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: compact
            ? "repeat(auto-fill, minmax(280px, 1fr))"
            : "repeat(auto-fill, minmax(340px, 1fr))",
          gap: compact ? "1rem" : "1.5rem",
          "@media (max-width: 768px)": { gridTemplateColumns: "1fr" }
        }}
      >
        {sortCatalog(items, order, popularityScores)
          .slice(0, limit)
          .map(renderItem)}
      </Box>
    </>
  );
}
